var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._l(_vm.applicantsToRender, function (applicant) {
        return _c(
          "div",
          { key: applicant.id, staticClass: "inline-block max-w-full" },
          [
            _c("ApplicantChip", {
              attrs: {
                contractorId: applicant.contractorId,
                applicantId: applicant.id,
                applicantName: applicant.name,
              },
            }),
          ],
          1
        )
      }),
      _vm.applicantsMoreThanLimit
        ? _c(
            "div",
            { staticClass: "ml-2 inline-block" },
            [
              _c(
                "RouterLink",
                {
                  attrs: {
                    to: {
                      name: _vm.routes.RECRUITING_POSTING_APPLICATIONS,
                      params: { id: _vm.postingId },
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "truncate text-primary-600 cursor-pointer" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.applicants.length - _vm.limit) +
                          " more... "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }